// core/cabangOpsi — SATU sumber daftar cabang untuk semua filter.
//
// Sebelum ini tiap menu menyusun daftarnya sendiri dari DATA yang kebetulan ada
// (`[...new Set(rows.map(r => r.outlet))]`). Akibatnya cabang yang baru dibuka — yang belum punya
// tiket, survei, atau pembayaran — tak pernah muncul di filter mana pun, dan pemiliknya mengira
// datanya hilang. Daftar cabang harus datang dari DAFTAR CABANG, bukan dari jejak transaksi.
import { supabase } from '@core/supabase';
import { currentUser } from '@core/session';
import { esc } from '@domain/format';

export interface CabangOpsi { kode: string; nama: string }

let cache: CabangOpsi[] = [];

/** Ambil daftar cabang (dengan ingatan sesaat, karena filter dirender berkali-kali). */
export async function cabangOpsi(): Promise<CabangOpsi[]> {
  if (cache.length) return cache;
  try {
    const { data, error } = await supabase().from('outlets').select('kode,nama').order('kode');
    if (error) throw new Error(error.message);
    cache = (data ?? []) as CabangOpsi[];
  } catch { /* biarkan kosong — pemanggil tetap bisa menampilkan "Semua cabang" */ }
  return cache;
}

/** Buang ingatan — dipanggil setelah cabang ditambah/diubah supaya filter langsung ikut. */
export const resetCabangOpsi = (): void => { cache = []; };

/**
 * `<option>` untuk filter cabang. Peran bercabang-tunggal (CS, Teknisi, Finance cabang) hanya
 * melihat cabangnya sendiri — menampilkan cabang lain yang datanya tetap kosong karena RLS
 * hanya membingungkan.
 */
export async function opsiCabangHTML(dipilih: string, semuaLabel = 'Semua cabang'): Promise<string> {
  const u = currentUser();
  const semua = await cabangOpsi();
  const isMgr = ['Owner', 'Manager'].includes(u?.role ?? '');
  const list = isMgr || !u?.outlet ? semua : semua.filter((c) => c.kode === u.outlet);
  const kepala = list.length > 1 ? `<option value="">${esc(semuaLabel)}</option>` : '';
  return kepala + list.map((c) =>
    `<option value="${esc(c.kode)}" ${dipilih === c.kode ? 'selected' : ''}>${esc(c.nama)}</option>`).join('');
}

/** Versi serentak — untuk fungsi gambar-ulang yang tak boleh menunggu jaringan.
 *  Panggil `cabangOpsi()` sekali di awal layar supaya ingatannya sudah terisi. */
export function opsiCabangSyncHTML(dipilih: string, semuaLabel = 'Semua cabang'): string {
  const u = currentUser();
  const isMgr = ['Owner', 'Manager'].includes(u?.role ?? '');
  const list = isMgr || !u?.outlet ? cache : cache.filter((c) => c.kode === u.outlet);
  const kepala = list.length > 1 ? `<option value="">${esc(semuaLabel)}</option>` : '';
  return kepala + list.map((c) =>
    `<option value="${esc(c.kode)}" ${dipilih === c.kode ? 'selected' : ''}>${esc(c.nama)}</option>`).join('');
}
